/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-12-07 17:23:35
 * @LastEditTime: 2023-10-08 13:56:53
 * @LastEditors: 赵大壮
 */

class DZModelUser {

    name = "";

    token = "";

    auth = [];

    menus = [];

    constructor() {
        var userData = window.localStorage.getItem("village_manager");
        if (userData) {
            this.parse(JSON.parse(userData));
        }
    }

    parse(data: any) {
        this.name = data?.name ?? "";
        this.token = data?.token ?? "";
        this.menus = data?.menus ?? [];
        this.auth = data?.auth ?? [];
    }

    isLogin() {
        return !this.token.nyIsEmpty();
    }

    saveUserData(data: any) {
        window.localStorage.setItem("village_manager", JSON.stringify(data));
    }

    /**
     * @description: 从缓存更新用户数据，常用于浏览器新增标签后退出
     */
    updateCache() {
        var userData = window.localStorage.getItem("village_manager");
        if (userData) {
            this.parse(JSON.parse(userData));
        } else {
            this.parse({});
        }
    }

    logout() {
        window.localStorage.removeItem("village_manager");
        this.updateCache();
    }

}

export default DZModelUser
